import styles from './ProfBackgroundItem.module.scss';

const ProfBackgroundItem = ({ index, title, subTitle, timeInterval }) => (
  <div className={styles.profBackgroundItemWrapper}>
    <div className={styles.profItemIndex}>{`${index + 1}.`}</div>
    <div className={styles.profItemSecondWrapper}>
      <div className={styles.profItemTitle}>{title}</div>
      <div className={styles.profItemSubTitle}>{subTitle}</div>
      <div className={styles.profItemTimeInterval}>{timeInterval}</div>
    </div>
  </div>
);

export default ProfBackgroundItem;
